module.exports = __webpack_public_path__ + "img/05.f9ae0919.jpg";